import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
import CreateView from "./Create/View";
import DetailView from "./Detail/View";
import UpdateView from "./Update/View";
import SubmitView from "./Submit/View";
import SubmissionView from "./Submission/View";
import PegawaiView from "./Pegawai/View";
import ApproveView from "./Approve/View";
import ApprovePeriodView from "./ApprovePeriod/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _uuid = queryParams.get("uuid");
  const _create = queryParams.get("create");
  const _detail = queryParams.get("detail");
  const _delete = queryParams.get("detail");
  const _approve = queryParams.get("approve");
  const _approve_period = queryParams.get("approveperiod");
  const _print = queryParams.get("print");
  const _update = queryParams.get("update");
  const _submit = queryParams.get("submit");
  const _submission = queryParams.get("submission");
  const _pegawai = queryParams.get("pegawai");

  if (_create != null) {
    return accessRole("create") ? <CreateView /> : <ErrorAccess />;
  } else if (_detail != null) {
    return accessRole("read") ? <DetailView uuid={_uuid} /> : <ErrorAccess />;
  } else if (_update != null) {
    return accessRole("update") ? <UpdateView uuid={_uuid} /> : <ErrorAccess />;
  } else if (_submit != null) {
    return accessRole("create") && accessRole("update") ? (
      <SubmitView uuid={_uuid} />
    ) : (
      <ErrorAccess />
    );
  } else if (_submission != null) {
    return accessRole("create") && accessRole("update") ? (
      <SubmissionView />
    ) : (
      <ErrorAccess />
    );
  }
  // else if (_pegawai != null) {
  //   return accessRole('create') && accessRole('update') ? <PegawaiView uuid={_uuid} /> : <ErrorAccess />
  // }
  else if (_delete != null) {
    return null;
  } else if (_approve != null) {
    return accessRole("create") && accessRole("update") ? (
      <ApproveView uuid={_uuid} />
    ) : (
      <ErrorAccess />
    );
  } else if (_approve_period != null) {
    return accessRole("create") && accessRole("update") ? (
      <ApprovePeriodView uuid={_uuid} />
    ) : (
      <ErrorAccess />
    );
  } else if (_print != null) {
    return null;
  }
  return accessRole("read") ? <PegawaiView /> : <ErrorAccess />;
};
export default RouteView;
